import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["itemsField"];

  connect() {
    this.toggle();
  }

  toggle() {
    const selected = this.element.querySelector(
      "input[type=radio][name*='has_allergy']:checked"
    );
    const isPresent = selected?.value === "true";

    this.itemsFieldTargets.forEach((element) => {
      element.classList.toggle("is-hidden", !isPresent);
    });
  }
}
